export default ((): any => {
    if (typeof window !== "undefined") {
        return window;
    } else if (typeof global !== "undefined") {
        return global;
         
    } else if (typeof self !== "undefined"){
         
        return self;
    } else {
        return {};
    }
})();

export const hasWindow = ((): any => {
    if (typeof window !== "undefined") {
        return true;
    } else if (typeof global !== "undefined") {
        return true;
         
    } else if (typeof self !== "undefined"){
         
        return true;
    } else {
        return false;
    }
})();
